export default __webpack_public_path__ + "static/media/cook9.bd830c49.png";